<template>
  <span :data-component-name="$options.name">
    <template v-if="isKnown">{{ value }}</template>
    <span v-else class="text-danger fw-bold">{{ unavailableText }}</span>
  </span>
</template>

<script>
import BasicHelper from '@ebg/vue-common/src/helpers/BasicHelper.js';

const UNAVAILABLE_TEXT_CODE = 'HOLIDAY_BALANCE_UNAVAILABLE';

export default {
  name: 'HolidayBalance',

  props: {
    value: {
      type: Number,
      default: null
    }
  },

  computed: {
    isKnown () {
      return this.value !== null && this.value !== undefined;
    },

    unavailableText () {
      return BasicHelper.getTranslation(
        this.$store.getters.getParamFromConfigByFilter('texts', 'code', UNAVAILABLE_TEXT_CODE, 'name')
      );
    }
  }
};
</script>
